var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObstacles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9866 11.9995L9.65329 2.66617C9.537 2.46097 9.36836 2.29029 9.16457 2.17154C8.96078 2.0528 8.72915 1.99023 8.49329 1.99023C8.25743 1.99023 8.02579 2.0528 7.822 2.17154C7.61822 2.29029 7.44958 2.46097 7.33329 2.66617L1.99995 11.9995C1.88241 12.2031 1.82077 12.4341 1.82129 12.6692C1.82181 12.9042 1.88447 13.135 2.00292 13.338C2.12136 13.5411 2.29138 13.7092 2.49575 13.8254C2.70011 13.9415 2.93156 14.0016 3.16662 13.9995H13.8333C14.0672 13.9993 14.297 13.9375 14.4995 13.8204C14.702 13.7032 14.8701 13.5349 14.987 13.3322C15.1038 13.1296 15.1653 12.8998 15.1653 12.6658C15.1652 12.4319 15.1036 12.2021 14.9866 11.9995Z",
    stroke: "#E17100",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 6V8.66667",
    stroke: "#E17100",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11.334H8.50667",
    stroke: "#E17100",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObstacles);
export default __webpack_public_path__ + "static/media/obstacles.0537cd6e702a107d291d0d6074b12358.svg";
export { ForwardRef as ReactComponent };